import { request } from '@/shared/api/request'

export const getAll = (data, params) => {
	return request({ url: '/proactive/get/page', method: 'POST', data: data, params: params })
}
